/* eslint-disable react-hooks/exhaustive-deps */
import { Card, Checkbox } from "antd";
import { useEffect, useState } from "react";
interface Props {
  data: any;
  viewOnly?: boolean;
}

export default function DetailsTemplateMultipleCheGrid({
  data,
  viewOnly,
}: Props) {
  const [selections, setSelections] = useState<Record<number, number[]>>({});

  // Define columns and rows for the grid
  const columns: string[] = data?.grid_columns || [];
  const rows: string[] = data?.grid_rows || [];
  const answers: Record<string, string[]> = data?.answer || {};

  const handleCheckboxChange = (
    rowIndex: number,
    colIndex: number,
    checked: boolean,
  ) => {
    if (viewOnly) {
      if (answers && rows.length > 0 && columns.length > 0) {
        const defaultSelections: Record<number, number[]> = {};

        rows.forEach((rowLabel, rowIndex) => {
          const selectedOptions = answers[rowLabel]; // e.g., ["Lower Price", "More Features"]
          if (Array.isArray(selectedOptions)) {
            const selectedIndices = selectedOptions
              .map((option) => columns.indexOf(option))
              .filter((index) => index !== -1); // filter out invalid indices

            defaultSelections[rowIndex] = selectedIndices;
          }
        });

        setSelections(defaultSelections);
        return;
      }
      return;
    }
    setSelections((prev) => {
      const prevRow = prev[rowIndex] || [];
      const updatedRow = checked
        ? [...prevRow, colIndex]
        : prevRow.filter((item) => item !== colIndex);

      return { ...prev, [rowIndex]: updatedRow };
    });
  };

  // Set default checkbox selections from "answer"
  useEffect(() => {
    if (answers && rows.length > 0 && columns.length > 0) {
      const defaultSelections: Record<number, number[]> = {};

      rows.forEach((rowLabel, rowIndex) => {
        const selectedOptions = answers[rowLabel]; // e.g., ["Lower Price", "More Features"]
        if (Array.isArray(selectedOptions)) {
          const selectedIndices = selectedOptions
            .map((option) => columns.indexOf(option))
            .filter((index) => index !== -1); // filter out invalid indices

          defaultSelections[rowIndex] = selectedIndices;
        }
      });

      setSelections(defaultSelections);
    }
  }, [data]);
  return (
    <>
      <Card className="mt-4">
        <div className="self-stretch justify-start text-zinc-700 text-base font-medium">
          Multiple Checked Grid - {data?.question_title}
        </div>

        <div className="overflow-x-auto mt-6">
          <table className="min-w-full table-fixed border-separate border-spacing-y-2">
            <thead>
              <tr>
                <th className="w-1/3 text-left"></th>
                {columns.map((col, index) => (
                  <th
                    key={index}
                    className="text-center text-slate-700 text-base font-medium"
                  >
                    {col}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((rowLabel, rowIndex) => (
                <tr key={rowIndex} className=" bg-slate-100 rounded-lg">
                  <td className="py-3 px-4 text-sm text-gray-700">
                    {rowLabel}
                  </td>
                  {columns.map((_, colIndex) => (
                    <td key={colIndex} className="text-center">
                      <Checkbox
                        checked={selections[rowIndex]?.includes(colIndex)}
                        onChange={(e) =>
                          handleCheckboxChange(
                            rowIndex,
                            colIndex,
                            e.target.checked,
                          )
                        }
                      />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </>
  );
}
